import { EnvConfig } from '~/app/utils/feature-flag'

export type FeatureFlagKey = 'newGlobalOrderCX3Pages'

type FeatureFlags = Record<FeatureFlagKey, EnvConfig>

export const featureFlagsConfig: FeatureFlags = {
  newGlobalOrderCX3Pages: {
    local: true,
    dev: true,
    qa: true,
    stage: true,
    prod: true,
  },
}
